import React from 'react';
import {TouchableOpacity, View, StyleSheet, Text, Image} from 'react-native';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import {
  DietaryHealthGood,
  DietaryHealthWarning,
  DietaryHealthAlert,
} from 'src/components/img/svg/DietaryHealthGrades';
import AVFormattedCurrency from '../AVFormattedCurrency';
import Styles from '../../Styles';
import {DNA} from 'src/types/dnaTypes';

type SearchProductProps = {
  imageUrl?: string;
  name: string;
  price: number;
  item?: any;
  dnaConfiguration?: DNA;
  onPress: () => void;
};

/** Remove arrow functions for optimization */
function SearchProduct(props: SearchProductProps) {
  // isDisabled = false --> DNA is enabled
  // Color codes don't make sense without knowing the calories
  // ---> const showHealthGrade = !props?.dnaConfiguration?.isDisabled && props?.dnaConfiguration?.showColorCodes && props?.dnaConfiguration?.showCalories;
  const showHealthGrade =
    !props?.dnaConfiguration?.isDisabled &&
    props?.dnaConfiguration?.showColorCodes;
  const calories = props.item?.calories;

  let imageURL = null;
  if (props.imageUrl !== null) {
    imageURL = (
      <Image source={{uri: props.item?.smallimageurl}} style={styles.image} />
    );
  }

  let healthGrade = null;
  let parsedCalorieValue = parseInt(calories);

  // calories is a number
  if (showHealthGrade === true) {
    if (!isNaN(parsedCalorieValue)) {
      // calories is a number greater than or equal to 0
      if (parsedCalorieValue >= 0) {
        if (parsedCalorieValue <= props?.dnaConfiguration?.levelGreenMax) {
          healthGrade = (
            <View style={styles.healthGrade}>
              <DietaryHealthGood />
            </View>
          );
        } else if (
          parsedCalorieValue <= props?.dnaConfiguration?.levelYellowMax
        ) {
          healthGrade = (
            <View style={styles.healthGrade}>
              <DietaryHealthWarning />
            </View>
          );
        } else {
          healthGrade = (
            <View style={styles.healthGrade}>
              <DietaryHealthAlert />
            </View>
          );
        }
      } else {
        
        healthGrade = null;
      }
    }
    // calories is null or undefined
    else {
      healthGrade = null;
    }
  } else {
    healthGrade = null;
  }

  return (
    <TouchableOpacity onPress={props.onPress}>
      <View style={styles.container}>
        <View style={styles.cellContent}>
          {imageURL !== null && (
            <View style={styles.imageContainer}>{imageURL}</View>
          )}

          <View style={styles.mainCellContent}>
            <Text style={styles.productName}>{props.name}</Text>

            <View style={styles.row}>
              {(props.dnaConfiguration?.showCalories && calories !== null) && (
                <Text style={styles.productCalories}>{calories} CAL</Text>
              )}
              {healthGrade}
            </View>
          </View>

          <View style={styles.row}>
            <AVFormattedCurrency
              style={styles.productPrice}
              value={props.price}
              accessibilityLabel="Item Price"
            />

            <FontAwesome5Pro
              name="chevron-right"
              color={Styles.auxColor}
              size={Styles.Fonts.f2}
              light
            />
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  row: {
    flexDirection: 'row',
  },
  cellContent: {
    flexDirection: 'row',
    borderBottomColor: Styles.bgColor,
    borderBottomWidth: 1,
    alignItems: 'center',
    paddingVertical: Styles.Spacing.m2,
    paddingHorizontal: Styles.Spacing.m3,
  },
  mainCellContent: {
    flex: 1,
    justifyContent: 'space-between',
    flexDirection: 'column',
    marginRight: Styles.Spacing.m2,
    padding: 7.5,
  },
  productName: {
    fontSize: 18,
    fontWeight: '600',
    paddingRight: 8,
    marginVertical: Styles.Spacing.m2,
  },
  productCalories: {
    fontSize: 14,
    color: Styles.gray20,
    marginRight: Styles.Spacing.m1,
  },
  productPrice: {
    fontSize: 14,
    color: Styles.black,
    marginRight: 10,
  },
  image: {
    backgroundColor: Styles.menuPlaceholderColor,
    borderRadius: 20,
    width: 85,
    height: 85,
  },
  imageContainer: {
    flexDirection: 'column',
    marginRight: Styles.Spacing.m2,
  },
  healthGrade: {},
});

export default SearchProduct;
